/**
 * @file util
 */

export function formatTimeNumber(number) {
    return number < 10 ? `0${number}` : `${number}`;
}

export function isAvailable(v) {
    return v !== undefined;
};
